/* ============
 * All Business Hours Exception
 * ============
 */

import Vue from 'vue';
import store from './../../store';
import businessHourExceptionTransformer from './../../transformers/businessHourException';

const success = ({ data }, resolve) => {
  const hours = businessHourExceptionTransformer.fetchCollection(data.data);

  store.dispatch('fetchBusinessHourExceptions', hours);
  resolve();
};

const failed = () => {
};

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('business_hour_exceptions')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/businessHourException/all.js